import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { gov } from "@/lib/governanceApi";
import { Switch } from "@/components/ui/switch";
import { card, Pill, SectionTitle, errMsg } from "./ui";

export default function Accounts() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["gov-accounts"], queryFn: gov.accounts });
  const run = async (fn, msg) => { try { await fn(); toast.success(msg); qc.invalidateQueries({ queryKey: ["gov-accounts"] }); } catch (e) { toast.error(errMsg(e)); } };
  if (!data) return null;
  return (
    <div className="space-y-5">
      <SectionTitle sub="Only authorised workspaces can access customer data. Review this list regularly (access review) and disable anything you don't recognise. Every change is recorded in the audit trail.">Accounts & access review</SectionTitle>
      <div className={card} data-testid="accounts-teams">
        <div className="px-4 py-2 border-b-2 border-zinc-100 text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500">Workspaces ({data.teams.length})</div>
        {data.teams.map((t) => (
          <div key={t.id} className="flex items-center justify-between px-4 py-3 border-b border-zinc-100 last:border-0">
            <div className="text-sm"><strong>{t.name}</strong> <span className="text-xs text-zinc-400 font-mono ml-2">{t.created_at?.slice(0, 10)}</span> {t.provider && <Pill value="provider" />}</div>
            <label className="flex items-center gap-2 text-xs">Authorised for customer data
              <Switch data-testid={`team-auth-${t.id}`} checked={!!t.authorised} disabled={t.provider} onCheckedChange={(v) => run(() => gov.setTeam(t.id, { authorised: v }), v ? "Workspace authorised" : "Workspace access revoked")} />
            </label>
          </div>
        ))}
      </div>
      <div className={card} data-testid="accounts-users">
        <div className="px-4 py-2 border-b-2 border-zinc-100 text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500">Users ({data.users.length})</div>
        {data.users.map((u) => (
          <div key={u.id} className="flex flex-wrap items-center justify-between gap-2 px-4 py-3 border-b border-zinc-100 last:border-0">
            <div className="text-sm">
              <strong>{u.name}</strong> <span className="font-mono text-xs text-zinc-500">{u.email}</span>
              <span className="text-xs text-zinc-400 ml-2">{u.team_name} · {u.role}{u.platform_role ? ` · ${u.platform_role}` : ""} · {u.email_verified ? "verified" : "unverified"} · joined {u.created_at?.slice(0, 10)}</span>
            </div>
            {u.platform_role !== "super_admin" && (
              <label className="flex items-center gap-2 text-xs">{u.disabled ? <Pill value="disabled" /> : "Active"}
                <Switch data-testid={`user-active-${u.id}`} checked={!u.disabled} onCheckedChange={(v) => run(() => gov.setUser(u.id, { disabled: !v }), v ? "Account enabled" : "Account disabled")} />
              </label>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
